// Dropdown Component
/* eslint indent: 0 */

import React, { Component } from 'react'
import ReactDom from 'react-dom'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import events from './events.jsx'
import IntlUtil from '../../../lib/intlutil.jsx'
import IntlMessage from '../../common/intl/intl_message.jsx'

class Dropdown extends Component {
  constructor (props) {
    super(props)

    this.state = {
      active: false,
      up: false
    }
  }

  static get propTypes () {
    return {
      allowBlank: PropTypes.bool,
      auto: PropTypes.bool,
      className: PropTypes.string,
      disabled: PropTypes.bool,
      error: PropTypes.string,
      label: PropTypes.string,
      name: PropTypes.string,
      onBlur: PropTypes.func,
      onChange: PropTypes.func,
      onFocus: PropTypes.func,
      source: PropTypes.array.isRequired,
      template: PropTypes.func,
      multilingual: PropTypes.bool,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    }
  }

  static get defaultProps () {
    return {
      auto: true,
      className: '',
      allowBlank: true,
      disabled: false,
      multilingual: true
    }
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillUpdate (nextProps, nextState) {
    if (!this.state.active && nextState.active) {
      events.addEventsToDocument({ click: this._handleDocumentClick })
    }
  }

  componentDidUpdate (prevProps, prevState) {
    if (prevState.active && !this.state.active) {
      events.removeEventsFromDocument({ click: this._handleDocumentClick })
    }
  }

  componentWillUnmount () {
    if (this.state.active) {
      events.removeEventsFromDocument({ click: this._handleDocumentClick })
    }
  }

  render () {
    const { template, source, multilingual, label } = this.props
    const selected = this._getSelectedItem()
    const className = classnames(
      'dropdown',
      {
        'dropdown-up': this.state.up,
        'dropdown-active': this.state.active,
        'dropdown-disabled': this.props.disabled
      },
      this.props.className
    )

    return (
      <div className={className}>
        <div className='form-input input'>
          <input
            className='input input-element dropdown-value'
            type='text'
            readOnly
            placeholder={IntlUtil.convertMessage(label)}
            onClick={this._handleMouseDown} // eslint-disable-line react/jsx-handler-names
            value={
              selected && selected.label
                ? multilingual
                  ? IntlUtil.convertMessage(selected.label)
                  : selected.label
                : ''
            }
          />
        </div>
        {template && selected ? this._renderTemplateValue(selected) : null}
        <ul className='dropdown-values' ref='values'>
          {source.map(this._renderValue)}
        </ul>
      </div>
    )
  }

  /* Event handlers */
  _handleSelect = (item, event) => {
    if (this.props.onBlur) this.props.onBlur(event)
    if (!this.props.disabled && this.props.onChange) {
      if (this.props.name) {
        event.target.name = this.props.name
      }
      this.props.onChange(item, event)
      this.setState({ active: false })
    }
  }

  close = () => {
    if (this.state.active) {
      this.setState({ active: false })
    }
  }

  _handleDocumentClick = event => {
    if (
      this.state.active &&
      !events.targetIsDescendant(event, ReactDom.findDOMNode(this))
    ) {
      this.setState({ active: false })
    }
  }

  _handleMouseDown = event => {
    events.pauseEvent(event)
    const client = event.target.getBoundingClientRect()
    const screenHeight =
      window.innerHeight || document.documentElement.offsetHeight
    const up = this.props.auto
      ? client.top > screenHeight / 2 + client.height
      : false
    if (this.props.onFocus) this.props.onFocus(event)
    this.setState({ active: true, up })
  }

  /* Private functions */
  _renderTemplateValue () {
    const selected = this._getSelectedItem()
    const className = classnames('dropdown-field', {
      'dropdown-errored': this.props.error,
      'dropdown-disabled': this.props.disabled
    })

    let tempLabel = null
    if (this.props.label) {
      tempLabel = (
        <label className='dropdown-label'>
          <IntlMessage
            ident={this.props.label}
            multilingual={this.props.multilingual}
          />
        </label>
      )
    }

    let tempError = null
    if (this.props.error) {
      tempError = (
        <span className='dropdown-error'>
          <IntlMessage
            ident={this.props.error}
            multilingual={this.props.multilingual}
          />
        </span>
      )
    }

    return (
      // eslint-disable-next-line react/jsx-handler-names
      <div className={className} onMouseDown={this._handleMouseDown}>
        <div className='dropdown-template-value dropdown-value'>
          {this.props.template(selected)}
        </div>
        {tempLabel}
        {tempError}
      </div>
    )
  }

  _renderValue = (item, idx) => {
    const className =
      item.value === this.props.value ? 'dropdown-selected' : null
    const { multilingual } = this.props
    return (
      <li
        key={idx}
        className={className}
        onMouseDown={this._handleSelect.bind(this, item.value)}
      >
        {this.props.template
          ? this.props.template(item)
          : multilingual
          ? IntlUtil.convertMessage(item.label)
          : item.label}
      </li>
    )
  }

  _getSelectedItem = () => {
    for (const idx in this.props.source) {
      if (this.props.source[idx]) {
        const item = this.props.source[idx]
        if (item.value === this.props.value) return item
      }
    }
    if (!this.props.allowBlank) {
      return this.props.source[0]
    }

    return ''
  }
}

export default Dropdown
